<div [formGroup]="formGroup" class="d-inline-flex align-items-center flex-nowrap p-1 rounded w-100">
  <div class="mx-1" [style.flex]="'0 1 150px'" [style.min-width.px]="0">
    <mat-form-field appearance="fill" class="w-100">
      <mat-label>Recurrence</mat-label>
      <mat-select formControlName="type">
        <mat-option value="weekly">Weekly</mat-option>
        <mat-option value="monthlyByDay">Monthly (by Day of Week)</mat-option>
        <mat-option value="monthlyByDate">Monthly (by Date)</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <ng-container *ngIf="formGroup.get('type')?.value === 'weekly'">
    <div class="mx-1" [style.flex]="'1 1 280px'" [style.min-width.px]="0">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Weekdays</mat-label>
        <mat-select formControlName="weekdays" multiple>
          <mat-option *ngFor="let d of weekdays" [value]="d.value">{{ d.label }}</mat-option>
        </mat-select>
        <mat-error *ngIf="formGroup.get('weekdays')?.hasError('required')">
          Select at least one weekday.
        </mat-error>
      </mat-form-field>
    </div>

    <div class="mx-1" [style.flex]="'0 1 125px'" [style.min-width.px]="0">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Repeat (weeks)</mat-label>
        <mat-select formControlName="weeklyInterval">
          <mat-option *ngFor="let w of weeks" [value]="w.value">{{ w.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container *ngIf="formGroup.get('type')?.value === 'monthlyByDay'">
    <div class="mx-1" [style.flex]="'0 1 100px'" [style.min-width.px]="0">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Week of Month</mat-label>
        <mat-select formControlName="weekOfMonth">
          <mat-option [value]="1">1st</mat-option>
          <mat-option [value]="2">2nd</mat-option>
          <mat-option [value]="3">3rd</mat-option>
          <mat-option [value]="4">4th</mat-option>
          <mat-option [value]="5">5th</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="mx-1" [style.flex]="'1 1 240px'" [style.min-width.px]="0">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Weekdays</mat-label>
        <mat-select formControlName="weekdays" multiple>
          <mat-option *ngFor="let d of weekdays" [value]="d.value">{{ d.label }}</mat-option>
        </mat-select>
        <mat-error *ngIf="formGroup.get('weekdays')?.hasError('required')">
          Select at least one weekday.
        </mat-error>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container *ngIf="formGroup.get('type')?.value === 'monthlyByDate'">
    <div class="mx-1" [style.flex]="'0 1 125px'" [style.min-width.px]="0">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Day of Month</mat-label>
        <input matInput type="number" min="1" max="31" formControlName="dayOfMonth" />
      </mat-form-field>
    </div>
  </ng-container>

  <div class="mx-1" [style.flex]="'0 1 125px'" [style.min-width.px]="0">
    <mat-form-field appearance="fill" class="w-100">
      <mat-label>Start</mat-label>
      <input matInput type="time" formControlName="startTime" required />
    </mat-form-field>
  </div>

  <div class="mx-1" [style.flex]="'0 1 125px'" [style.min-width.px]="0">
    <mat-form-field appearance="fill" class="w-100" subscriptSizing="fixed">
      <mat-label>End</mat-label>
      <input matInput type="time" formControlName="endTime" required />
      <mat-error *ngIf="formGroup.get('endTime')?.hasError('timeOrder')">
        End time must be after start time.
      </mat-error>
    </mat-form-field>
  </div>


  <div class="ms-auto d-inline-flex align-items-center mx-0">
    <button mat-icon-button class="m-0" color="warn" type="button" (click)="remove.emit()" aria-label="Remove shift">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
</div>